import { Star } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";

const Stars = ({ rating, size = 16, testId }) => (
  <div className="flex gap-0.5" data-testid={testId} aria-label={`${rating} out of 5 stars`}>
    {[1, 2, 3, 4, 5].map((n) => (
      <Star
        key={n}
        size={size}
        strokeWidth={1}
        className={n <= rating ? "text-gold" : "text-gold-light"}
        fill={n <= rating ? "currentColor" : "none"}
      />
    ))}
  </div>
);

export const Reviews = ({ reviews = [] }) => {
  const avg = reviews.length
    ? (reviews.reduce((s, r) => s + r.rating, 0) / reviews.length).toFixed(1)
    : "5.0";

  return (
    <section id="reviews" className="py-24 md:py-32" data-testid="reviews-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-[1fr_auto] gap-12 items-end">
          <SectionHeading
            eyebrow="Customer Reviews"
            title={<>Loved, worn &amp; <span className="italic gold-text">repurchased</span></>}
            copy="Hear from the people who made these patches part of their routine."
          />
          <Reveal delay={0.1}>
            <div className="flex items-center gap-5 lg:pb-2" data-testid="overall-rating">
              <span className="font-display text-6xl md:text-7xl text-ink leading-none">{avg}</span>
              <div>
                <Stars rating={Math.round(Number(avg))} size={18} testId="overall-rating-stars" />
                <p className="mt-2 text-xs text-[#8C8C8C] tracking-wide">{reviews.length} reviews</p>
              </div>
            </div>
          </Reveal>
        </div>
        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {reviews.map((r, i) => (
            <Reveal key={r.id} delay={(i % 3) * 0.07}>
              <figure
                data-testid={`review-card-${i}`}
                className="h-full rounded-2xl border border-champagne/70 bg-white p-7 transition-[box-shadow] duration-500 hover:shadow-[0_16px_40px_rgb(201,162,39,0.10)]"
              >
                <Stars rating={r.rating} testId={`review-stars-${i}`} />
                <blockquote className="mt-4 text-[15px] text-[#3d3d3d] leading-relaxed">“{r.text}”</blockquote>
                <figcaption className="mt-5 flex items-center gap-3">
                  <span className="w-9 h-9 rounded-full bg-champagne flex items-center justify-center font-display text-lg text-gold-deep">
                    {r.name.charAt(0)}
                  </span>
                  <span className="text-sm font-semibold text-ink" data-testid={`review-name-${i}`}>{r.name}</span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
